import { getFullName, getInitials, Profile } from "@clockwise/web-commons/src/util/profile.util";
import { Avatar } from "@material-ui/core";
import React from "react";

type Props = {
  profile: Profile;
  size: "small" | "large";
  "cw-id"?: string;
  "aria-label"?: string;
};

export function UserAvatar({ profile, size, "cw-id": cwId, "aria-label": ariaLabel }: Props) {
  const { givenName, familyName, externalImageUrl } = profile;
  const initials = getInitials(profile);

  if (!externalImageUrl && !givenName && !familyName) {
    return null;
  }

  const sizeClass = size === "small" ? "cw-h-9 cw-w-9 cw-text-16" : "cw-h-12 cw-w-12";

  return (
    <Avatar
      alt={getFullName(profile)}
      src={externalImageUrl || undefined}
      className={`${sizeClass} cw-text-white cw-bg-gradient-to-br cw-from-blue-standard cw-to-green-standard`}
      cw-id={cwId}
      aria-label={ariaLabel}
    >
      {initials}
    </Avatar>
  );
}
